import React from 'react'
import { Link } from 'gatsby'
import Helmet from 'react-helmet'
import Layout from '../components/layout'
import BannerLanding from '../components/BannerLanding'
import GalleryComponent from '../components/Gallery'

const IrrigationSystem = (props) => (
  <Layout>
    <Helmet>
      <title>Landscape Lighting</title>
      <meta
        name="description"
        content="Be the best house in your neighborhood, even in the night"
      />
    </Helmet>
    <BannerLanding
      title="Landscape Lighting"
      descript="Be the best house in your neighborhood, even in the night"
    />
    <div id="main">
      <section id="one">
        <div className="inner" style={{ overflow: 'hidden' }}>
          <header className="major">
            <h2>Take a look of our work</h2>
          </header>
          <GalleryComponent type="lighting" />
        </div>
      </section>
    </div>
  </Layout>
)

export default IrrigationSystem
